export { default } from './TitleHeaderPortraitContainer';
